module.exports = __webpack_public_path__ + "media/img/about/bg-story-4a6fa1a5c54fd5e75ecad7d1d3e8273c.png";